import React from 'react';
import { INLINES } from '@contentful/rich-text-types';
import Link from 'src/components-v2/Inputs/Link/Link';

const MAIN_ADDRESS = 'plaid.com';

const Hyperlink = ({ hyperlink }, sys) => {
  return {
    [INLINES.ASSET_HYPERLINK]: (node, children) => {
      // NOTE: we typically do not create links to assets in rich text
      return null;
    },
    [INLINES.ENTRY_HYPERLINK]: (node, children) => {
      // NOTE: we typically do not create links to entries in rich text
      return null;
    },
    [INLINES.HYPERLINK]: (node, children) => {
      const uri = node?.data?.uri;
      return (
        <Link href={uri}>
          <a target={uri.includes(MAIN_ADDRESS) ? null : '_blank'}>
            {children}
          </a>
        </Link>
      );
    },
  };
};

export default Hyperlink;
